// extracted by mini-css-extract-plugin
export default {"number":"BaselineItemTotals_number__vFtAX","baselineItemCompanies":"BaselineItemTotals_baselineItemCompanies__fDJai","total":"BaselineItemTotals_total__z-ZW5"};